import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { useTranslation } from 'react-i18next';

import { fieldWrapperStyle } from 'common/style/fields.style';
import { generateSectionStyle } from 'common/style/cssStyleType';
import NameDescription from 'common/components/NameDescription';
import FileUpload from 'common/components/FileUpload';
import withSettings from 'editor/components/FormContent/Field/withSettings';
import { below } from 'common/utils/breakpoint';

function FieldFileUpload({
    fieldId,
    value,
    displayName,
    description,
    error,
    touched,
    setFieldTouched,
    setFieldError,
    setFieldValue,
    settingStyle,
    isRequired
}) {
    const { t } = useTranslation();
    const { displayNameStyle, descStyle, answerStyle } = generateSectionStyle(settingStyle);
    function handleFileUpload(file) {
        setFieldValue(fieldId, file);
        if (!touched) {
            setFieldTouched(fieldId);
        }
    }
    function handleUploadError() {
        setFieldError(fieldId, t('form.upload_wrong_file'));
        if (!touched) {
            setFieldTouched(fieldId, true, false);
        }
    }
    function handleClearFile() {
        setFieldValue(fieldId, '');
    }
    return (
        <div css={css(fieldWrapperStyle)} id={`section_${fieldId}`}>
            <NameDescription
                displayName={displayName}
                description={description}
                displayNameStyle={displayNameStyle}
                descStyle={descStyle}
                isRequired={isRequired}
            />
            <div css={uploadWrapperStyle}>
                <FileUpload
                    onChange={handleFileUpload}
                    onError={handleUploadError}
                    onClear={handleClearFile}
                    value={value[fieldId]}
                    style={answerStyle}
                />
            </div>
            {error && touched && (
                <span css={css(errorStyle)} id="feedback">
                    {error}
                </span>
            )}
        </div>
    );
}

FieldFileUpload.propTypes = {
    fieldId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    displayName: PropTypes.string,
    description: PropTypes.string,
    error: PropTypes.string,
    touched: PropTypes.bool,
    setFieldValue: PropTypes.func,
    setFieldTouched: PropTypes.func,
    setFieldError: PropTypes.func,
    settingStyle: PropTypes.object,
    isRequired: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export default withSettings(FieldFileUpload);

const errorStyle = `
    text-align: right;
    font-size: 0.8125rem;
    line-height: 1.1875rem;
    color: #D52027;
    ${below('sm')} {
        float: right;
    }
`;

const uploadWrapperStyle = css`
    display: inline-block;
    width: 60%;
    ${below('sm')} {
        width: 100%;
        display: block;
    }
`;
